import React from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import DialogRoutes, {CommonDialogProps} from './DialogRoutes';

function DialogRoutesWrapper(props: CommonDialogProps) {
   const navigate = useNavigate();
   const location = useLocation();

   return <DialogRoutes {...props} navigate={navigate} location={location} />;
}

export default DialogRoutesWrapper;
